import React, { useMemo } from 'react';
import { findCup, useSaucerDispatch, setNodeAttrsAction, } from '@saucerjs/core';
import { RenderWrapper } from '../components/RenderWrapper';
import { TeaAttrsContext } from '../context/TeaAttrsContext';
import { RenderInteractiveMask } from '../components/RenderInteractiveMask';
var ChildrenContextBuilder = React.memo(function (props) {
    var dispatch = useSaucerDispatch();
    var contextVal = useMemo(function () { return ({
        currentTeaAttrs: props.attrs,
        setCurrentTeaAttrs: function (newAttrs) {
            dispatch(setNodeAttrsAction({ nodeId: props.id, newAttrs: newAttrs }));
        },
    }); }, [props.id, props.attrs]);
    return (React.createElement(TeaAttrsContext.Provider, { value: contextVal }, props.children));
});
ChildrenContextBuilder.displayName = 'ChildrenContextBuilder';
export function renderChildren(children, prefixPath, _a) {
    if (prefixPath === void 0) { prefixPath = ''; }
    var _b = _a.hasWrapper, hasWrapper = _b === void 0 ? false : _b;
    return children.map(function (node, index) {
        var _a, _b;
        var cup = findCup(node.cupName);
        if (cup === null) {
            return null;
        }
        var nodeId = node.id;
        var path = prefixPath === '' ? String(index) : prefixPath + "." + index;
        var body;
        var CupRender = cup.render;
        CupRender.displayName = "SaucerElement(" + cup.name + ")";
        var renderInteractive = (_a = cup.renderInteractive) !== null && _a !== void 0 ? _a : false;
        if (node.type === 'container') {
            body = (
            // TODO const { setCurrentTeaAttrs } = useCurrentTeaAction();
            // <TeaAttrsContext value={{currentTeaAttrs: node.attrs, }}></TeaAttrsContext>
            React.createElement(CupRender, { nodeId: nodeId, node: node, path: path, attrs: node.attrs }, renderChildren(node.children, path, { hasWrapper: hasWrapper })));
        }
        else {
            body = (React.createElement(CupRender, { nodeId: nodeId, node: node, path: path, attrs: node.attrs }));
        }
        if (node.type === 'leaf' && renderInteractive === false) {
            // Only for leaf node
            // Forbid to interactive with render component
            body = React.createElement(RenderInteractiveMask, null, body);
        }
        // Wrap Children attrs edit context
        body = (React.createElement(ChildrenContextBuilder, { id: nodeId, attrs: node.attrs }, body));
        if (hasWrapper) {
            var disableDropEvent = (_b = cup.disableDropEvent) !== null && _b !== void 0 ? _b : false;
            return (React.createElement(RenderWrapper, { key: nodeId, path: path, tea: node, canDrop: !disableDropEvent }, body));
        }
        else {
            return React.createElement("div", { key: nodeId }, body);
        }
    });
}
